import useBasicInfo from './useBasicInfo';

const useDebugFeaturesAreEnabled = () => {
    const basicInfo = useBasicInfo();
    return basicInfo && basicInfo.debugFeaturesEnabled;
};
export default useDebugFeaturesAreEnabled;
